export const config={
    baseUrl:`http://localhost:3001`
}
export const  baseUrl=`http://localhost:3001`